import Typography from '@repo/ui/typography'

type ItemNotFoundProps = {
  title: string
}

/**
 * renders a full screen with a title in the middle
 * @param title
 * @returns
 */
export function ItemNotFound({ title }: ItemNotFoundProps) {
  return (
    <div className="flex justify-center items-center h-full p-3">
      <Typography variant="h4">{title}</Typography>
    </div>
  )
}
